(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annonce"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root = document) {
      root.querySelectorAll('[data-cab-countdown]').forEach(banner => {
        if (
          banner.dataset.enabled !== 'true' ||
          banner.dataset.bound
        ) return;

        banner.dataset.bound = 'true';

        const display = banner.querySelector('[data-cab-display]');
        const hours = Math.max(
          1,
          Number(banner.dataset.duration) || 6
        );

        const key =
          'sd_timer_' + banner.dataset.cabCountdown + '_' + hours;

        let endTime;

        try {
          endTime = Number(localStorage.getItem(key));
        } catch {}

        if (!Number.isFinite(endTime) || endTime <= 0) {
          endTime = Date.now() + hours * 3600000;

          try {
            localStorage.setItem(key, String(endTime));
          } catch {}
        }

        let interval;

        function update() {
          if (!banner.isConnected) {
            clearInterval(interval);
            return;
          }

          const remaining = Math.max(
            0,
            Math.floor((endTime - Date.now()) / 1000)
          );

          const h = Math.floor(remaining / 3600);
          const m = Math.floor(remaining % 3600 / 60);
          const s = remaining % 60;

          display.textContent = [h, m, s]
            .map(value => String(value).padStart(2, '0'))
            .join(' : ');

          if (!remaining) clearInterval(interval);
        }

        update();

        if (endTime > Date.now()) {
          interval = setInterval(update, 1000);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', event => {
      init(event.target.parentElement);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-guide-popup"]) return;
  try {
    
  if (!window.sdGuidePopupBound) {
    window.sdGuidePopupBound = true;
    document.addEventListener('click', (event) => {
      const dialog = document.getElementById('sd-guide-dialog');
      if (!dialog) return;
      if (event.target.closest('[data-sd-guide-open]')) {
        if (!dialog.open) dialog.showModal();
      } else if (event.target.closest('[data-sd-guide-close]')) {
        dialog.close();
      } else if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.target.matches('[data-sd-guide-open][role="button"]') && ['Enter', ' '].includes(event.key)) {
        event.preventDefault();
        event.target.click();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    root.querySelectorAll('[data-sd-hero-video]').forEach(video => {
      if (video.dataset.bound) return;
      video.dataset.bound = 'true';
      const mobile = matchMedia('(max-width:749px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let visible = false;
      const update = () => {
        if (reduced.matches || navigator.connection?.saveData || document.hidden || !visible) {
          video.pause();
          if (reduced.matches) video.removeAttribute('data-playing');
          return;
        }
        const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (!source) return;
        if (video.getAttribute('src') !== source) {
          video.removeAttribute('data-playing');
          video.src = source;
          video.load();
        }
        video.muted = true;
        video.play().catch(() => video.removeAttribute('data-playing'));
      };
      video.addEventListener('playing', () => video.setAttribute('data-playing', ''));
      video.addEventListener('error', () => video.removeAttribute('data-playing'));
      mobile.addEventListener('change', update);
      reduced.addEventListener('change', update);
      document.addEventListener('visibilitychange', update);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        update();
      }, {threshold:.05});
      observer.observe(video.parentElement);
      const cleanup = event => {
        if (!event.target.contains(video)) return;
        observer.disconnect();
        video.pause();
        mobile.removeEventListener('change', update);
        reduced.removeEventListener('change', update);
        document.removeEventListener('visibilitychange', update);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-product-notes"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.sdPyramidMotion) return;
  window.sdPyramidMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const selector = '.sd-pyramid__heading, .sd-pyramid__note';
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      observer.unobserve(element);
      if (reduced.matches || typeof element.animate !== 'function') return;
      const notes = element.parentElement.classList.contains('sd-pyramid__notes');
      const index = notes ? Array.from(element.parentElement.children).indexOf(element) : 0;
      const offset = notes ? (index % 2 === 0 ? -14 : 14) : 0;
      const animation = element.animate([
        {opacity:0,transform:`translate3d(${offset}px,-18px,0)`},
        {opacity:1,transform:'translate3d(0,0,0)'}
      ], {duration:650,delay:Math.min(index * 55,220),easing:'cubic-bezier(.2,.65,.3,1)',fill:'backwards'});
      const stop = () => animation.cancel();
      reduced.addEventListener('change', stop, {once:true});
      animation.finished.catch(() => {}).finally(() => reduced.removeEventListener('change', stop));
    });
  }, {threshold:0.15,rootMargin:'0px 0px -24px 0px'});
  const init = root => root.querySelectorAll(selector).forEach(element => {
    if (seen.has(element)) return;
    seen.add(element);
    if (!reduced.matches) observer.observe(element);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll(selector).forEach(element => observer.unobserve(element)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-product-row"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sd-product-row')) {
  customElements.define('sd-product-row', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.rail = this.querySelector('.sd-row-rail');
      this.controls = this.querySelector('.sd-row-controls');
      this.previous = this.querySelector('[data-row-direction="previous"]');
      this.next = this.querySelector('[data-row-direction="next"]');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.previous.addEventListener('click', () => this.move(-1), {signal});
      this.next.addEventListener('click', () => this.move(1), {signal});
      this.rail.addEventListener('scroll', () => this.update(), {signal, passive:true});
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.update();
    }
    move(direction) {
      const card = this.rail.querySelector('.sd-card');
      const gap = parseFloat(getComputedStyle(this.rail).gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const count = Math.max(1, Math.floor(this.rail.clientWidth / step));
      this.rail.scrollBy({left:direction * step * count, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    update() {
      const end = this.rail.scrollWidth - this.rail.clientWidth;
      this.controls.hidden = end <= 2;
      this.previous.disabled = this.rail.scrollLeft <= 2;
      this.next.disabled = this.rail.scrollLeft >= end - 2;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
